import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Modal } from "@website/ui/modal";
import { ReserveGalleryDetail } from "@website/widget/reserve-gallery-detail";
import { useReserveGalleryDetailContainer } from "@website/widget/reserve-gallery/reserve-gallery-detail-container/reserve-gallery-detail-container.hooks";
import { ReserveGalleryDetailContainerPropertiesTypes } from "@website/widget/reserve-gallery/reserve-gallery-detail-container/reserve-gallery-detail-container.types";
export const ReserveGalleryDetailContainer = t0 => {
  const $ = _c(22);
  const {
    title,
    gallery,
    isModalOpen,
    onClose
  } = t0;
  const t1 = gallery?.length ?? 0;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      templateNumber: 4,
      galleryLength: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    containerProps
  } = useReserveGalleryDetailContainer(t2);
  const t3 = isModalOpen ? "" : "hidden";
  let t4;
  if ($[2] !== onClose) {
    t4 = <MaterialIcon className="text-on-surface-medium-emphasis cursor-pointer text-2xl" name="arrow_forward" onClick={onClose} />;
    $[2] = onClose;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = title || "\u06AF\u0627\u0644\u0631\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0647\u062A\u0644";
  let t6;
  if ($[4] !== t5) {
    t6 = <span className="text-subtitle-1">{t5}</span>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t6) {
    t7 = <div className="border-b-outline-thin flex h-[64px] w-full border-b px-2 md:px-6 xl:px-[calc((100%-1200px)/2)]"><div className="flex h-full flex-row items-center justify-start gap-2 lg:max-w-[1200px]">{t4}{t6}</div></div>;
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== containerProps || $[10] !== gallery) {
    t8 = containerProps?.map(t9 => {
      let {
        index,
        rowCount
      } = t9;
      return <ReserveGalleryDetail gallery={gallery} index={index} key={`HotelReserveGalleryDetailContainer-${++index}`} rowCount={rowCount} />;
    });
    $[9] = containerProps;
    $[10] = gallery;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <div className="grid h-full grid-cols-2 gap-2 overflow-y-auto p-2 lg:px-[calc((100%-750px)/2)] lg:py-6">{t8}</div>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isModalOpen || $[15] !== onClose || $[16] !== t7 || $[17] !== t9) {
    t10 = <Modal fullScreen={true} onClose={onClose} open={isModalOpen}>{t7}{t9}</Modal>;
    $[14] = isModalOpen;
    $[15] = onClose;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3) {
    t11 = <div className={t3}>{t10}</div>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};